import React, { memo } from 'react';

import { Block } from '../../components/core';
import { PerformanceAndRiskHeader } from './performance-and-risk-header';
import { PerformanceAndRiskContent } from './performance-and-risk-content';

import { MetricsErrorWrapper } from '../../../studio-blocks/components/error-wrappers/MetricsErrorWrapper';
import { COMMON_ERROR_WRAPPERS } from '../../../studio-blocks/components/error-wrappers/common';

interface PerformanceAndRiskBlockProps {
  id: string;
}

export const PerformanceAndRiskBlock = memo(function InternalPerformanceAndRiskBlock({
  id,
}: PerformanceAndRiskBlockProps) {
  return (
    <Block.Root id={id}>
      <Block.Header>
        <PerformanceAndRiskHeader id={id} />
      </Block.Header>

      <Block.Content
        id={id}
        errorWrappers={[
          ...COMMON_ERROR_WRAPPERS,
          // MetricsErrorWrapper is last because it requires analysis, so we might as well do all the client-side error checks first
          MetricsErrorWrapper,
        ]}
      >
        <PerformanceAndRiskContent id={id} />
      </Block.Content>
    </Block.Root>
  );
});
